import focusManager from "focus-manager";
import {ToggleScroll} from "@main/components/toggle-scroll";
    
/** Класс модального окна с требованиями. */
class ModalRequirements {
    documentEl = document.body

    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} modal Элемент.
     */
    constructor(modal) {
        this.modal = modal;
        this.textPlace = this.modal.querySelector(".js-modal-requirements-place");
        
        this.bindEventListeners();
    }

    /**
     * При клике открыть модал и показать текст.
     * 
     * @returns {void}
     */
    bindEventListeners() {
        document.addEventListener("click", (e) => {
            let item;
            if (e.target.classList.contains("js-open-modal-requirements")) {
                item = e.target;
            } else {
                item = e.target.closest(".js-open-modal-requirements");
            }
            if (item) {
                this.textPlace.innerHTML = item.querySelector(".js-modal-requirements-text").innerHTML;
                this.showModal();
            }
        });
    }

    /**
     * Открытие модального окна.
     * 
     * @returns {void}
     */
    showModal = () => {    
        this.modal.classList.add("shown");
        ToggleScroll.disable(this.modal);
        focusManager.capture(this.modal);
    }
}
    
window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-modal[data-modal='requirements']")
        .forEach(el => new ModalRequirements(el));
});
